import * as yup from "yup";

export const fieldsConfig = {
  login: {
    label: "Email",
    type: "email",
    required: true,
    placeholder: 'Email',
    schema: yup.string().email("Email tidak valid").required("Email wajib diisi"),
  },
  password: {
    label: "Password",
    type: "password",
    required: true,
    placeholder: 'Password',
    schema: yup
      .string()
      .required("Password wajib diisi")
  },
};

const schemaShape = Object.fromEntries(
  Object.entries(fieldsConfig).map(([key, val]) => [key, val.schema])
);

export const schema = yup.object().shape(schemaShape);

export const loginFields = Object.entries(fieldsConfig);

export type FormValues = yup.InferType<typeof schema>;
